var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_profile_main_div"},[_c('Profile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }